import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ToastProvider from "./Context/ToastContext/ToastContext";
import { ToastContainer } from "./Components/StyledComponents/Toast";
import {getHomeRoutes} from "./pages/Home/Home";
import { AutherRoutes } from "./pages/AutherRoutes";
import CompleteAuth from "./pages/CompleteAuth";



import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ToastProvider>
          <ToastContainer />
          <Routes>
            <Route path="complete-auth" element={<CompleteAuth />} />
            <Route element={<AutherRoutes />}>
                {getHomeRoutes()}
            </Route>
          </Routes>
        </ToastProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
